const calculateTotals = (cart) => {
  const totals = {
    totalShippingCost: 0,
    totalDiscount: 0,
    totalBalanceAmount: 0,
    totalProducts: 0
  };

  if (cart && typeof cart === "object") {
    Object.values(cart).forEach((item) => {
      if (item && typeof item === "object") {
        totals.totalShippingCost += parseFloat(item.shipping_cost) || 0;

        if (item.summary && typeof item.summary === "object") {
          totals.totalDiscount += parseFloat(item.summary.products_discount) || 0;
          totals.totalBalanceAmount += parseFloat(item.summary.total_amount) || 0;
        }

        if (item.items && typeof item.items === "object") {
          Object.values(item.items).forEach((product) => {
            totals.totalProducts += parseInt(product.count, 10) || 0;
          });
        }
      }
    });
  }

  totals.totalShippingCost = parseFloat(totals.totalShippingCost.toFixed(2));
  totals.totalDiscount = parseFloat(totals.totalDiscount.toFixed(2));
  totals.totalBalanceAmount = parseFloat(totals.totalBalanceAmount.toFixed(2));

  return totals;
};

export default calculateTotals;
